import { render, staticRenderFns } from "./SingleExamReport.vue?vue&type=template&id=71c6dc25"
import script from "./SingleExamReport.vue?vue&type=script&lang=js"
export * from "./SingleExamReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports